<template>
    <v-container>

        <v-row no-gutters>
          <v-col cols="12" class="text-right" >
            <v-btn rounded depressed class="pl-4" color="primary" @click="showStepper()">
              <v-icon left size="18">mdi-calendar</v-icon>
              nueva cita
            </v-btn>
          </v-col>
        </v-row>

      <v-row>
        <v-col cols="12"  >
          <v-card class="kim-card" color="secondary-card" >
            <v-card-text>
              <v-row  align="center" justify="center">

                <v-col cols="12" sm="4">
                  <v-menu
                      ref="date"
                      v-model="showDate"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                          filled
                          v-model="dateFormatted"
                          label="Fecha"
                          placeholder="Sin filtrar"
                          readonly
                          clearable
                          @click:clear="date = ''"
                          hide-details
                          persistent-hint
                          prepend-inner-icon="event"
                          @blur="date = parseDate(date)"
                          :disabled="loading || preLoading || firstLoad"
                          v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date" no-title @input="showDate = false" locale="es-es"></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" sm="4" >
                  <event-status-picker
                      ref="statusPicker"
                      @blur="onEventStatusBlur"
                      multiple
                      label="Estado"
                      :value="defaultStatuses"
                      v-on:loaded="onStatusesLoaded"
                      v-on:change="onStatusSelect"
                      :serviceProviderId="currentProvider.id"
                  />
                </v-col>

                <v-col cols="12" sm="4">
                  <specialist-picker
                      ref="specialistPicker"
                      default-all-selected
                      :value="specialists"
                      required
                      multiple
                      @blur="onSpecialistBlur"
                      label="Especialistas"
                      v-on:loaded="onSpecialistsLoaded"
                      v-on:change="onSpecialistSelect"
                      :serviceProviderId="currentProvider.id"
                  />
                </v-col>

              </v-row>
              <v-row  align="center" justify="center" class="mt-2">

                <v-col cols="12" :md="useLabelsOnAppointments ? 8 : 12"  class="text-center">
                  <v-text-field
                      :disabled="loading || preLoading || firstLoad"
                      clearable
                      filled
                      @click:clear="term=''"
                      @keyup.enter="getAppointments"
                      hide-details
                      v-model="term"
                      prepend-inner-icon="search"
                      @click:prepend-inner="getAppointments"
                      label="Búsqueda rápida"
                      placeholder="Rut, nombre, email o telefono"
                  />
                </v-col>

                <v-col v-if="useLabelsOnAppointments" cols="12" md="4" class="my-1 px-3">
                  <label-picker @change="labels = $event" filled type="event" disable-creation/>
                </v-col>

              </v-row>
            </v-card-text>
          </v-card>
          <v-card class="kim-card mt-2">
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12 text-center pt-2>
                  <v-progress-linear class="mt-1" color="primary" height="2" width="1" v-if="loading || preLoading || firstLoad" indeterminate/>
                  <v-slide-y-transition>
                    <appointments-list
                        ref="appointmentsList"
                        v-on:select="onAppointmentSelect"
                        @click:appointment="onNewAppointmentClick"
                        @click:modify="onNewAppointmentModifyClick"
                        v-show="!loading && !preLoading && !firstLoad"
                        :items="items"
                        :total="totalAppointments"
                    />
                  </v-slide-y-transition>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>




        <appointment-provider-stepper
              internal
              @appointment-created="onAppointmentCreated"
              ref="stepper"/>

        <v-snackbar
                v-model="snackBar"
                :color="snackBarColor"
                bottom
                multi-line
                :timeout="6000"
        >
            {{ snackBarText }}
            <v-btn
                    color="white"
                    text
                    @click="snackBar = false"
            >
                Cerrar
            </v-btn>
        </v-snackbar>
    </v-container>
</template>
<script>

    import WMainTitle from '@/components/common/WMainTitle'
    import AppointmentsList from '@/components/providers/panel/AppointmentsList'
    import AppointmentProviderStepper from '@/components/appointments/AppointmentProviderStepper'
    import SpecialistPicker from '@/components/providers/SpecialistPicker'
    import EventStatusPicker from '@/components/providers/schedule/EventStatusPicker'

    import {mapMutations, mapState} from 'vuex'
    import {ApiUtils} from '@/utils/ApiUtils'
    import {subscribeToPrivateChannelEvents, leaveChannel} from '@/utils/Sockets'
    import {getStatusColor} from '@/utils/ScheduleEvent'
    import ProviderSettingsMixin from "@/mixins/ProviderSettingsMixin";
    import LabelPicker from "@/components/common/LabelPicker";
    import AppointmentsMixin from "@/mixins/AppointmentsMixin";
    import ClientAttentionHistory from "@/components/appointments/attention/ClientAttentionHistory";


    export default{
        mixins: [ProviderSettingsMixin, AppointmentsMixin],
        components: {
          LabelPicker,
            WMainTitle,
            AppointmentsList,
            SpecialistPicker,
            EventStatusPicker,
            AppointmentProviderStepper
        },
        beforeDestroy(){
            var vm = this
            if(vm.currentProvider){
                leaveChannel(`provider.${vm.currentProvider.id}`)
            }
        },
        data(vm){
            return {

                snackBar: false,
                snackBarColor: 'green',
                snackBarText: false,

                firstLoad: true,
                loading: false,
                loadingOffices: true,
                loadingSpecialists: true,
                loadingStatuses: true,
                loadingServices: false,
                showDate: false,
                date: vm.$moment().format('YYYY-MM-DD'),
                dateFormatted: vm.formatDate(vm.$moment().format('YYYY-MM-DD')),
                term: '',
                specialists: [],
                labels: [],
                appointments: [],
                totalAppointments: 0,
                nextAppointmentsUrl: null,
                selectedSchedule: null,
                defaultStatuses: [],
                defaultServices: [],
                selectedServices: [],
                selectedAppointmentStatus: [],
                breadcrumbs: [
                    {
                        text: 'Todas las Citas',
                        disabled: true,
                        href: ''
                    }
                ],
            }
        },
        mounted(){
            var vm = this

            if(vm.currentProvider){
                subscribeToPrivateChannelEvents(`provider.${vm.currentProvider.id}`, {
                  AttentionPaymentUpdated: vm.onPaymentUpdated,
                  ClientUpdated: vm.onClientUpdated,
                  AppointmentCreated: vm.onAppointmentCreated,
                  ClientArrived: vm.onClientArrived,
                  AppointmentConfirmed: vm.onAppointmentConfirmed,
                  EventCancelled: vm.onAppointmentCancelled,
                  EventLabelsUpdated: vm.updateEventFromSocketUpdate,
                  AppointmentDocumentUploaded: vm.updateEventFromSocketUpdate,
                  AppointmentDocumentDeleted: vm.updateEventFromSocketUpdate,
                  ClientAttentionStart: vm.updateEventFromSocketUpdate,
                  ClientAttentionEnd: vm.updateEventFromSocketUpdate,
                  ClientAttentionReopen: vm.updateEventFromSocketUpdate,
                })
            }
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            notify(message = '', color = 'primary'){
                var vm = this
                vm.snackBarText = message
                vm.snackBarColor = color
                vm.snackBar = true
            },
            highlight(eventId){

                var vm = this
                vm.$nextTick(function(){

                    var foundIndex = vm.appointments.findIndex(appointment => {
                        return appointment.id === eventId
                    })

                    if(foundIndex === -1) return

                    const appointment = JSON.parse(JSON.stringify(vm.appointments[foundIndex]))
                    appointment.highlighted = true
                    vm.appointments.splice(foundIndex, 1, appointment)

                    setTimeout(function(){
                       var foundIndex = vm.appointments.findIndex(appointment => {
                           return appointment.id === eventId
                       })

                       if(foundIndex === -1) return

                       const appointment = JSON.parse(JSON.stringify(vm.appointments[foundIndex]))
                       appointment.highlighted = false
                       vm.appointments.splice(foundIndex, 1, appointment)

                    }, 6000)


                })


            },
            onAppointmentConfirmed(evt){

                var vm = this

                const newEvent = JSON.parse(JSON.stringify(evt.event))
                const foundIndex = vm.appointments.findIndex(event => event.id === newEvent.id)

                if(foundIndex === -1) return
                vm.appointments.splice(foundIndex, 1, newEvent)

                const message = `La cita de ${newEvent.client.first_name} ${newEvent.client.last_name} ha sido confirmada`
                const messageColor = getStatusColor(newEvent.event_status_id)
                vm.showSnackBar({
                    text: message,
                    color: messageColor
                })

                vm.highlight(newEvent.id)

            },

            onClientArrived(evt){
                var vm = this
                const newEvent = JSON.parse(JSON.stringify(evt.event))
                const foundIndex = vm.appointments.findIndex(event => event.id === newEvent.id)

                if(foundIndex === -1) return
                vm.appointments.splice(foundIndex, 1, newEvent)

                const message = `${newEvent.client.first_name} ${newEvent.client.last_name} ha sido ingresado`
                const messageColor = getStatusColor(newEvent.event_status_id)
                vm.showSnackBar({
                    text: message,
                    color: messageColor
                })
                vm.highlight(newEvent.id)

            },

            onAppointmentCancelled(evt){
                var vm = this
                const newEvent = JSON.parse(JSON.stringify(evt.event))
                const foundIndex = vm.appointments.findIndex(event => event.id === newEvent.id)

                if(foundIndex === -1) return
                vm.appointments.splice(foundIndex, 1, newEvent)

                const message = `La cita de las ${vm.$moment(newEvent.time, 'HH:mm:ss').format('HH:mm')} ha sido cancelada`
                const messageColor = getStatusColor(newEvent.event_status_id)
                vm.showSnackBar({
                    text: message,
                    color: messageColor
                })
                vm.highlight(newEvent.id)

            },
            onAppointmentCreatedTest(evt){
              console.log('appointment created test: ', evt)
            },
            eventMatchesCurrentFilters(event){
              const vm = this
              const {schedule, date, status} = event

              const eventSpecialistId = schedule.specialist_id || schedule.specialist.id
              const eventBranchOfficeId = schedule.branch_office_id || schedule.branch_office.id

              const eventDateIsSameAsCurrent = !vm.date || vm.date === date
              const eventSpecialistMatchCurrentFilter = vm.specialists.length === 0
                  || vm.specialists.find(specialist => specialist.id === eventSpecialistId)
              const eventStatusMatchCurrentFilter =  vm.selectedAppointmentStatus.length === 0 ||
                  vm.selectedAppointmentStatus.find(st => st.id === status.id)
              const eventBranchOfficeMatchesCurrentOffice = vm.currentBranchOffice.id === eventBranchOfficeId

              return eventDateIsSameAsCurrent &&
                  eventSpecialistMatchCurrentFilter &&
                  eventStatusMatchCurrentFilter &&
                  eventBranchOfficeMatchesCurrentOffice
            },
            onAppointmentCreated(evt){

                var vm = this
                const newEvent = evt.event

                console.log('new event incoming: ', newEvent)

                const foundIndex = vm.appointments.findIndex(evt => evt.id === newEvent.id)
                if(foundIndex !== -1){
                    vm.appointments.splice(foundIndex, 1, newEvent)
                    return
                }

                if(vm.eventMatchesCurrentFilters(newEvent)){
                    vm.appointments.push(newEvent)
                    const message = `Se ha agendado nueva cita a las ${vm.$moment(newEvent.time, 'HH:mm:ss').format('HH:mm')}`
                    const messageColor = getStatusColor(newEvent.event_status_id)
                    vm.showSnackBar({
                        text: message,
                        color: messageColor
                    })
                    vm.highlight(newEvent.id)
                }

            },
            onClientUpdated(updatedEntity){

                var vm = this

                for(let i in vm.appointments){

                    const event = JSON.parse(JSON.stringify(vm.appointments[i]))
                    const foundIndex = vm.appointments.findIndex(evt => evt.id === event.id)

                    if(foundIndex !== -1) {

                        if(event.client && updatedEntity.user && event.client.id === updatedEntity.user.id){
                            event.client = updatedEntity.user
                        }else{
                            const companionIndex = event.companions.findIndex(companion => companion.id === updatedEntity.user.id)
                            if(companionIndex !== -1){
                                event.companions.splice(companionIndex, 1, updatedEntity.user)
                            }
                        }

                        vm.appointments.splice(foundIndex, 1, event)
                    }

                }



            },
            onPaymentUpdated(updatedEntity){

                var vm = this
                for(let i in vm.appointments){
                    const event = JSON.parse(JSON.stringify(vm.appointments[i]))
                    if(event.payment && event.payment.id === updatedEntity.payment.id){
                        event.payment = updatedEntity.payment
                        const foundIndex = vm.appointments.findIndex(evt => evt.id === event.id)
                        if(foundIndex === -1) return
                        vm.appointments.splice(foundIndex, 1, event)
                    }
                }

            },
            onUpdateStatus(scheduleEvent){

                var vm = this
                const eventIndex = vm.appointments.findIndex(evt => {
                    return evt.id === scheduleEvent.id
                })



                if(eventIndex !== -1){
                    vm.appointments[eventIndex].event_status_id = scheduleEvent.event_status.id
                    vm.appointments[eventIndex].event_status = scheduleEvent.event_status
                }

            },
            onSpecialistBlur(specialists){
                var vm = this
                if(JSON.stringify(specialists) === JSON.stringify(vm.specialists)) return
                vm.specialists = specialists
                vm.$nextTick(function(){
                    vm.getAppointments()
                })

            },
            onEventStatusBlur(statuses){
                var vm = this
                if(JSON.stringify(statuses) === JSON.stringify(vm.selectedAppointmentStatus)) return
                vm.selectedAppointmentStatus = statuses
                vm.$nextTick(function(){
                    vm.getAppointments()
                })
            },
            /*onCancelSuccess(){
                this.getAppointments()
            },
            onArriveSuccess(){
                this.getAppointments()
            },
            onAppointmentCreated(){
                this.getAppointments()
            },*/
            onNewAppointmentClick(appointment){
                this.showStepper(appointment)
            },
            onNewAppointmentModifyClick(appointment){
                this.showStepper(appointment, true)
            },
            showStepper(defaultAppointment = null, allowModifying = false){
                this.$refs.stepper.show(defaultAppointment, allowModifying)
            },
            onSpecialistSelect(specialist){
                var vm = this
            },
            onStatusSelect(statuses){
                var vm = this
            },
            onServicesSelect(services){
                var vm = this
                vm.selectedServices = services
            },
            formatDate (date) {
                if (!date) return null
                var vm = this
                return vm.$moment(date).format('DD-MM-YYYY')
            },
            parseDate (date) {
                if (!date) return null
                const [year, month, day] = date.split('-')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
            onAppointmentSave(schedule){
                this.appointments.unshift(schedule)
            },
            addAppointment(){
                var vm = this
                vm.selectedMember = null
                vm.$refs.scheduleForm.show()
            },
            onAppointmentSelect(schedule){
                var vm = this
                vm.selectedAppointment = schedule
            },
            onAppointmentSetActive(updatedAppointment){
                var vm = this
                const updatedIndex = vm.appointments.findIndex(schedule => schedule.id === updatedAppointment.id)
                vm.appointments[updatedIndex].active = updatedAppointment.active
            },
            onOfficesLoaded(){
                this.loadingOffices = false
            },
            onSpecialistsLoaded(){
                this.loadingSpecialists = false
            },
            onStatusesLoaded(statuses){
                this.defaultStatuses = statuses
                this.loadingStatuses = false
            },
            onServicesLoaded(services){

                var serviceItems =[]
                for(let service of services){
                    serviceItems = [...serviceItems, ...service.service_items]
                }

                this.defaultServices = serviceItems
                this.loadingServices = false
            },
            async getAppointments(){

                var vm = this
                if(vm.loading) return
                if (!vm.currentProvider || !vm.currentBranchOffice) {
                    return
                }

                const url = `provider/${vm.currentProvider.id}/branch-office/${vm.currentBranchOffice.id}/appointments`

                vm.loading = true
                const response = await ApiUtils.makeGet(url, {
                    term: vm.term,
                    date: vm.date,
                    status: vm.selectedAppointmentStatus.map(item => item.id),
                    specialists: vm.specialists.map(item => item.id),
                    labels: vm.labels.map(lbl => lbl.id)
                })
                vm.loading = false

                if (!response.ok) {
                    const json = await response.json()
                    return vm.showSnackBar(json.message || 'Ha ocurrido un error intentando consultar citas')
                }

                const json = await response.json()
                const {result} = json
                vm.appointments = result.appointments.data
                vm.totalAppointments = result.appointments.total
                vm.nextAppointmentsUrl = result.appointments.next_page_url

            }
        },
        computed: {
            ...mapState(['currentProvider', 'currentBranchOffice']),
            items(){
                var vm = this
                return vm.appointments.map(appointment => {
                    appointment.time = vm.$moment(appointment.time, 'HH:mm:ss').format('HH:mm')
                    return appointment
                }).sort((a,b) => {
                    return vm.$moment(b.time, 'HH:mm') - vm.$moment(a.time, 'HH:mm')
                })
            },
            preLoading(){
                var vm = this
                return vm.loadingSpecialists === true || vm.loadingStatuses === true || vm.loadingServices === true
            }
        },
        watch: {
            labels(){
              this.getAppointments()
            },
            date (val) {
                this.dateFormatted = this.formatDate(val)
                this.getAppointments()
            },
            term(val){
                if(!val) this.getAppointments()
            },
            preLoading(val){
                var vm = this
                if(!val){
                    vm.$nextTick(function(){
                        vm.getAppointments()
                    })
                }
            },
            loading(val){
                if(!val){
                    this.firstLoad = false
                }
            },
            currentBranchOffice(val){
                if (val) {
                    this.getAppointments()
                }
            },

            selectedAppointmentStatus(val, oldVal){
                if(!val || val.length === 0) this.selectedAppointmentStatus = oldVal.slice()
            }

        }
    }
</script>

<style scoped>
    .picker-wrapper {
        position: absolute;
        top: 5px;
        right: 0px;
        max-width: 230px;
    }
</style>
